var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-upload-multiple" },
    [
      _c(
        "el-upload",
        {
          attrs: {
            "auto-upload": _vm.autoUpload,
            disabled: _vm.disabled,
            action: _vm.action,
            "show-file-list": false,
            name: _vm.name,
            data: _vm.data,
            "http-request": _vm.request,
            accept: _vm.accept,
            "before-upload": _vm.before,
            "on-remove": _vm.remove,
            "on-success": _vm.success,
            "on-error": _vm.error,
            "on-preview": _vm.handlePreview,
            "on-exceed": _vm.handleExceed,
          },
        },
        [
          _vm.imageUrl
            ? _c(
                "div",
                { staticClass: "image-upload-list-item" },
                [
                  _vm.disabled
                    ? _c("el-image", {
                        staticClass: "upload-image-size",
                        attrs: {
                          src: _vm.imageUrl,
                          fit: "cover",
                          "preview-src-list": [_vm.imageUrl],
                        },
                      })
                    : _c("el-image", {
                        staticClass: "upload-image-size",
                        attrs: { src: _vm.imageUrl, fit: "cover" },
                      }),
                  !_vm.disabled
                    ? _c("div", { staticClass: "image-upload__item-actions" }, [
                        _c(
                          "span",
                          {
                            staticClass: "del",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleRemove()
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-delete" })]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _c("div", { staticClass: "el-upload--picture-card " }, [
                _c("i", { staticClass: "el-icon-plus avatar-uploader-icon" }),
              ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }